export const isPublicPortalPath = (pathname: string | undefined) =>
  pathname === '/portals' || !!pathname?.startsWith('/portals/');
